import { t } from "i18next";
import { NotificationService, TypeAny } from "@brightinsight/bi-web-core";
import {
  ServiceLoader,
  UserManagementServiceTypes,
} from "@brightinsight/openapi-client";

interface CreateUserProps {
  userName: string;
  password: string;
  email: string;
  code: string;
  invitationIdentifierType: UserManagementServiceTypes.AcceptInvitationDTOWriteInvitationIdentifierTypeEnum;
  invitationIdentifier: string;
}
const createUser = async (createUserProps: CreateUserProps) => {
  try {
    const UserManagementService = await ServiceLoader.userManagementService;
    const emailCheckResponse =
      await UserManagementService.InvitationControllerApi.acceptInvitationRegistration(
        {
          acceptInvitationDTOWrite: createUserProps,
        }
      );
    return emailCheckResponse;
  } catch (e: TypeAny) {
    if (e?.status >= 400) {
      NotificationService.error({
        message: e?.response?.data?.issues[0]?.details || t("verifyTokenError"),
      });
    }
    return { success: false };
  }
};

export const RegisterPageProperties = {
  defaultEnrolementType: "invite",
  createUser,
};
